<span class="price-value">{{value}}<small v-if="suffix">{{ suffix }}</small></span>